import CrudRequest from '@rootCommon/services/crud-request';
import { SITE } from '@rootCommon/constants/end-points';
import { Site, SiteDto, SiteSelector } from '@rootCommon/types/site';
import { ADMIN } from '@rootCommon/constants/common';

const SITE_ADMIN = `${SITE}/${ADMIN}`;

class OrganizationService extends CrudRequest<Site, SiteDto> {
  constructor() {
    super(SITE_ADMIN);
  }

  getSelectorList = async (): Promise<SiteSelector> => {
    const res = await CrudRequest.get<SiteSelector>(`${SITE}/list`);

    return res.data;
  };
}

export default new OrganizationService();
